import { lazy } from 'react';
import { Permission, KNOWN_SLOTS, type SkillManifest } from '@brandschutz/shared';
import type { FrontendSkill } from '../_core/registry';

/**
 * Schlanker Skill-Descriptor für das Bootstrap — Slot-Renderer sind React.lazy,
 * sodass Button + Stats-Karte erst laden, wenn die Projekt-Detailseite rendert.
 */
const manifest: SkillManifest = {
  key: 'ai-field-prefill',
  name: 'KI-Feldvorschläge',
  description:
    'Erzeugt KI-Vorschläge für fachliche Brandschutz-Felder und stellt Übernahme-/Verwerfen-Aktionen pro Feld bereit.',
  category: 'ai',
  version: '0.1.0',
  requiredPermissions: [Permission.AI_USE, Permission.PROJECT_UPDATE],
  enabledByDefault: true,
};

const PrefillButton = lazy(() =>
  import('./PrefillButton').then((m) => ({ default: m.PrefillButton })),
);
const PrefillStatsCard = lazy(() =>
  import('./PrefillStatsCard').then((m) => ({ default: m.PrefillStatsCard })),
);

export const aiFieldPrefillSkill: FrontendSkill = {
  manifest,
  slots: {
    [KNOWN_SLOTS.PROJECT_DETAIL_COCKPIT_BELOW]: [
      {
        key: 'prefill-button',
        order: 10,
        // @ts-expect-error Slot context shape ist dynamic — Caller liefert projectId+readOnly
        render: PrefillButton,
      },
    ],
    [KNOWN_SLOTS.PROJECT_DETAIL_SIDEBAR]: [
      {
        key: 'prefill-stats',
        order: 5,
        // @ts-expect-error Slot context shape ist dynamic — Caller liefert projectId
        render: PrefillStatsCard,
      },
    ],
  },
};
